import React from 'react';
import styled from 'styled-components';
const SVG = styled.svg `
  path {
    stroke: ${({ isWhite, theme }) => (isWhite ? theme.primaryWhite : theme.primaryBlack)};
  }
`;
export const ScrollDownIcon = ({ isWhite }) => {
    return (React.createElement(SVG, { width: "21", height: "42", viewBox: "0 0 21 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", isWhite: isWhite || false },
        React.createElement("path", { d: "M10 25.1001V40.1001", strokeWidth: "2" }),
        React.createElement("path", { d: "M10 7.1001V13.1001", strokeWidth: "2" }),
        React.createElement("path", { d: "M7 37.1001L10 40.1001L13 37.1001", strokeWidth: "2" }),
        React.createElement("path", { d: "M12.3 31.1C16 31.1 19.1 28.1 19.1 24.3V7.8C19.1 4.1 16.1 1 12.3 1H7.8C4 1 1 4.1 1 7.8V24.3C1 28.1 4 31.1 7.8 31.1", strokeWidth: "1.8771" })));
};
